import { Avatar, Box, Card, styled, Typography } from "@mui/material";
import React, { useState } from "react";
import { successStories } from "./data";
import { styles } from "../styles/styles";
import { DecorativeCorner } from "../common/DecorativeCorner";

const StyledDot = styled("span")(({ active }) => ({
	display: "inline-block",
	width: "8px",
	height: "8px",
	borderRadius: "50%",
	margin: "0 4px",
	backgroundColor: active ? "#d3a260" : "#e0e0e0",
	cursor: "pointer",
	transition: "background-color 0.3s",
}));

function SuccessStoriesSection() {
	const [activeIndex, setActiveIndex] = useState(0);

	return (
		<Box
			sx={{
				width: "100%",
				display: "flex",
				justifyContent: "center",
			}}
		>
			<Card
				sx={{
					...styles.sucess,
					height: { xs: "auto", sm: 515 },
					padding: { xs: 2, sm: 4 },
					boxShadow: 3,

				}}
			>
				<DecorativeCorner sx={{ top: -20, left: -20 }} />
				<DecorativeCorner sx={{ top: -20, right: -20 }} />
				<DecorativeCorner sx={{ bottom: -20, right: -20 }} />
				<DecorativeCorner sx={{ bottom: -20, left: -20 }} />

				<Typography variant="h4" component="h1" sx={styles.heading}>
					Our Success Stories								</Typography>

				<Card
					sx={{
						...styles.testimonialsCard,
						display: "flex",
						flexDirection: { xs: "column", sm: "row" },
						alignItems: "center",
						padding: { xs: 2, sm: 3, md: 4 },
						gap: { xs: 0, sm: 4 },
						margin: "auto",
						width: "100%",
					}}
				>
					<Box
						sx={{
							
							...styles.avatarContainer,
							display: "flex",
							justifyContent: "center",
							width: { xs: "75%", sm: "20%" },
						}}
					>
						<Avatar
							src={successStories[activeIndex].image}
							sx={{
								...styles.avatar,
								width: { xs: 170, sm: 150, md: 200 },
								height: { xs: 170, sm: 170, md: 200 },
								boxShadow: 2,
							}}
							alt={successStories[activeIndex].name}
						/>
					</Box>
					<Box
						sx={{
							...styles.testimonialContent,
							textAlign: { xs: "center", sm: "left" },
							padding: { xs: 0, sm: 2, md: 3 },
							width: "100%",
							overflow: "visible",
						}}
					>

						<Typography
							variant="body1"
							sx={{
								...styles.testimonialText,
								fontSize: { xs: "12px", sm: "16px", md: "18px", lg: "20px" },
								lineHeight: { xs: 1, sm: 1.6, md: 1.8 },
							}}
						>
							"{successStories[activeIndex].testimonial}"
						</Typography>

						<Typography
							variant="subtitle1"
							sx={{
								...styles.coupleNames,
								fontWeight: "bold",
								marginTop: 1,
								fontSize: { xs: "16px", sm: "18px", md: "20px" },
							}}
						>
							{successStories[activeIndex].name}
						</Typography>

						<Typography
							variant="subtitle2"
							sx={{
								...styles.marriageSource,
								color: "gray",
								fontSize: { xs: "12px", sm: "14px", md: "16px" },
							}}
						>
							{successStories[activeIndex].platform}
						</Typography>
					</Box>
				</Card>

				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						marginTop: 2,
					}}
				>
					{successStories.map((_, index) => (
						<StyledDot
							key={index}
							active={index === activeIndex}
							onClick={() => setActiveIndex(index)}
						/>
					))}
				</Box>
			</Card>
		</Box>
	);
}

export default SuccessStoriesSection;